import React, { Component } from 'react';
import { Row, Col, Jumbotron } from 'reactstrap';
import { Link } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

class MyProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            displayName: this.props.user.displayName,
        }
    }


    componentDidMount() {
        var dbRef = firebase.database().ref("/user/" + firebase.auth().currentUser.uid);

        dbRef.on('value', (snapshot) => {
            let users = snapshot.val();
            console.log(users)
            this.setState({
                firstName: users.firstName,
                lastName: users.lastName,
                region: users.region,
                club: users.club,
                rating: users.rating,
                name: users.name,
                scoreHA: users.scoreHA,
                scoreHB: users.scoreHB,
                scoreC: users.scoreC,
                scoreD: users.scoreD,
                newUser: users.newUser
            })

        })
    }
    render() {
        return (
            <div>
                <UserInfo state={this.state} />
                <ThankYou />
            </div>
        )
    }
}

class UserInfo extends Component {
    render() {
        return (
            <div>
                <Jumbotron>
                    <Row>
                        <Col md='3'>
                            <img src='./img/ribbon.png' alt='Blue Ribbon' height='400px' />
                        </Col>
                        <Col>
                            <h1> {this.props.state.name} </h1>
                            <div>
                                <p style={{ fontWeight: 'bold', paddingTop: '2em' }}> Representing:  </p>
                                <p> {this.props.state.region} Region </p>
                                <p> {this.props.state.club} </p>
                            </div>
                        </Col>
                        <Col>
                            <h1> Personal High Scores </h1>
                            <Link to='/leaderboard'> View Leaderboard </Link>
                            <p style={{ paddingTop: '2em' }}> D-Level: {this.props.state.scoreD} / 20 </p>
                            <p> C-Level: {this.props.state.scoreC} / 20 </p>
                            <p> H-B: {this.props.state.scoreHB} / 20 </p>
                            <p> H-A: {this.props.state.scoreHA} / 20 </p>
                        </Col>
                    </Row>
                </Jumbotron>
            </div>
        )
    }
}

class ThankYou extends Component {
    render() {
        return (
            <div>
                <h1 style={{ textAlign: 'center' }}> Thank You for Playing! </h1>
                <p style={{ textAlign: 'center' }}> Brought to you by the United States Pony Clubs National Youth Board </p>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Link to='/about'>
                        <img src='./img/nyb-logo.png' alt='NYB Logo' width='400px' height='100px' />
                    </Link>
                </div>

            </div>
        )
    }
}

export default MyProfile;